/* eslint-disable import/no-named-as-default */

import DayJsAdapter from '@date-io/dayjs'

const date = {
  adapter: DayJsAdapter,
  locale: {
    bg: 'bg',
    cy: 'cy',
    de: 'de',
    de_CH: 'de-ch',
    en: 'en-gb',
    es: 'es',
    et: 'et',
    fr: 'fr',
    ga: 'ga',
    gu: 'gu',
    hi: 'hi',
    hu: 'hu',
    lt: 'lt',
    lv: 'lv',
    nl: 'nl',
    pl: 'pl',
    ro: 'ro',
    sk: 'sk',
    tr: 'tr',
    uk: 'uk',
    zh_CN: 'zh-cn',
    zh_TW: 'zh-tw',
  },
}

export default date
